import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="resource-modal"
export default class extends Controller {
  initialize() {
    console.log('resource-modal controller initialized')
    if ($('#resource-modal').data('bs.modal')?._isShown) {
      return;
    }

    $('#resource-modal').on('hidden.bs.modal', () => {
      this.disconnect();
    });

    $('#resource-modal').modal('show');
    
    document.addEventListener('turbo:submit-end', (e) => {
      if (e.target.dataset.resourceModalKeepOpen === 'true') return;

      const url = e.detail?.formSubmission?.fetchRequest?.url?.pathname;
      if (url && url.includes("/generate_label")) {
        const contentType =
          e.detail?.fetchResponse?.response?.headers?.get("content-type") || "";
        if (contentType.includes("text/vnd.turbo-stream.html")) {
          return;
        }
      }
      
      if (e.detail?.formSubmission?.fetchRequest?.body?.get('_method') === 'delete' && e.detail?.formSubmission?.fetchRequest?.url?.pathname?.includes('repairs')) {
        $('#resource-modal').modal('hide');
        return;
      }

      if (e.detail.success && e.detail.fetchResponse.response.status == 202) {
        $('#resource-modal').modal('hide');
        return;
      }

      if (e.detail?.formSubmission?.fetchRequest?.body?.get('_method') === 'delete') {
        return;
      }

      if (e.detail.success && e.detail.fetchResponse.response.status == 303) {
        return;
      }

      if (e.detail.success && e.detail.formSubmission.submitter.formMethod != 'get') {
        if (e.detail.fetchResponse.response.status == 303) {
          return;
        }
        if (e.detail.fetchResponse.response.status == 204) {
          return;
        }

        if (e.detail?.formSubmission?.fetchRequest?.url?.pathname.includes('comments')){
          return;
        }

        if (e.detail?.formSubmission?.fetchRequest?.url?.pathname.includes('labels')){
          return;
        }

        if (e.detail.fetchResponse.response.url != undefined) {
          if (e.detail.fetchResponse.response.url == window.location.href) {
            window.location.reload();
          } else {
            Turbo.visit(e.detail.fetchResponse.response.url, { action: 'replace' })
          }
        }
      }
    });
  }

  disconnect() {
    console.log('000resource-modal controller disconnected')
  }
}
